import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class GetUserAlertsUseCase extends UseCase {
  constructor({getUserAlertsService}) {
    super()
    this._getUserAlertsService = getUserAlertsService
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'GetUserAlertsUseCase#execute'})
  @inlineError
  async execute() {
    const [getUserAlertsError, getUserAlertsResponse] = await this._getUserAlertsService.execute()

    if (getUserAlertsError) return Promise.reject(getUserAlertsError)

    return getUserAlertsResponse.toJSON()
  }
}

export default GetUserAlertsUseCase
